import React from 'react';
import OrderAdditionalInfo from '../../../../containers/lifeline/orderAdditionalInfo';
import { OrderBasicInfoV1 } from '../../../widgets/Order';

const LifelineOrderInfoHeader = (props) => {
  const {
    orderId,
    userId,
    cartId,
    orderBasicInfo,
    comments,
    isOrderShimmer,
    getBasicOrderInfoForGivenId,
    getTransactionsDetails,
    getOrderBasicInfo,
    setTransactionDetails,
    openDominosPopup,
    showIssueBox = () => {},
    reloadOrder = () => {},
    openHelpSectionPopUp = () => {},
    openCallLogsModal = () => {},
    showCopilotView = () => {},
  } = props;

  return (
    <div className='tw-w-full tw-flex-col tw-gap-1'>
      <OrderBasicInfoV1
        orderId={orderId}
        userId={userId}
        cartId={cartId}
        order={orderBasicInfo?.order}
        getReplaceOrderBasicInfo={getBasicOrderInfoForGivenId}
        orderBasicInfo={orderBasicInfo}
        reloadOrder={reloadOrder}
        openHelpSectionPopUp={openHelpSectionPopUp}
        openCallLogsModal={openCallLogsModal}
        showIssueBox={showIssueBox}
        getTransactionsDetails={getTransactionsDetails}
        setTransactionDetails={setTransactionDetails}
        openDominosPopup={openDominosPopup}
        showCopilotView={showCopilotView}
      />
      <OrderAdditionalInfo
        orderBasicInfo={orderBasicInfo}
        isOrderShimmer={isOrderShimmer}
        orderId={orderId}
        userId={userId}
        cartId={cartId}
        comments={comments}
        retry={getOrderBasicInfo}
        getTransactionsDetails={getTransactionsDetails}
        setTransactionDetails={setTransactionDetails}
        openDominosPopup={openDominosPopup}
      />
    </div>
  );
};

export default LifelineOrderInfoHeader;
